import * as React from 'react';
import { AnchorLink } from "gatsby-plugin-anchor-links";
import {backgroundOregon, legendItemContainer, legendContainer, legendSmallContainer, chapterContainer, chapter, chapterDate, legendIcon, categoryContent, categoryTitle, categoryText, fixedLegend} from "./oregon-timeline.module.css"
import Header1 from '../../components/general-components/header1.js'
import TimelineLine from '../../components/timeline-components/timeline-line.js'
import SectionContainer from '../../components/timeline-components/section-container.js';
import StickyTimecard from '../../components/timeline-components/sticky-timecard.js';
import NotstickyCard from '../../components/timeline-components/notsticky-timecard.js'
import TimelineSub from '../../components/timeline-components/timeline-subheader.js';   
import headerdata from "./oregontimeline-headers.json";
import data from "./oregontimeline-timecards.json";
import politicalIcon from "../../pages/immigration-agriculture/icons/political-icon.svg";
import violenceIcon from "../../pages/immigration-agriculture/icons/violence-icon.svg";
import grassrootsIcon from "../../pages/immigration-agriculture/icons/grassroots-icon.svg"
import actionIcon from "../../pages/immigration-agriculture/icons/action-icon.svg"
import legend from "../../pages/immigration-agriculture/icons/category_legend.svg"


const OregonTimelinePage = () => {

    const subheaders = headerdata.filter(d => d.type == "subheader"); // filters header JSON file to select subheader data
    /* This next chunk of code generates a new page section for each subheading, and dynamically creates a sticky or non-sticky components based on priority within the page section */
    const pageContent = subheaders.map((subheader) => { 
        // filtering timeline events based on subsection dates
        const filteredEvents = data.filter(d => d.year >= subheader.startDate && d.year <= subheader.endDate); 

        // looping through filtered events and generating sticky or not-sticky timecard based on priority
        const listTimecards = filteredEvents.map((timelineEvent) => {

            if (timelineEvent.priority == "high") {
                return (
                    <>
                          <StickyTimecard data={data} id={timelineEvent.id} category={timelineEvent.category} centerGraphics={timelineEvent['center-graphics']} sideGraphics={timelineEvent['side-graphics']} graphicsAlign={timelineEvent['graphics-align']}>
                          </StickyTimecard>
                    </>
              );
            } else {
                return (
                    <>
                        <NotstickyCard data={data} id={timelineEvent.id} category={timelineEvent.category} centerGraphics={timelineEvent['center-graphics']} sideGraphics={timelineEvent['side-graphics']} graphicsAlign={timelineEvent['graphics-align']}>
                        </NotstickyCard>   
                    </>
                )   
            }
        });
        console.log(headerdata)
        // rendering container for subsection: includes the timeline line, subheader title and text, and the timecards generated above
        return (
                    
            <SectionContainer>
                <TimelineLine></TimelineLine>
                <TimelineSub id = {subheader.id} title={ subheader.title } text={ subheader.text }></TimelineSub>
                {listTimecards}
            </SectionContainer>
        
    )
        
   });

    return (
        // React requires wrapper for all DOM objects, using <> here
        <> 
            <title>Migrant Histories | Atlas of Essential Work</title>
            {/* I have a fixed position div here as a background color; I tried to wrap all the page objects in a div and apply a background color to that, but it left a weird white bar at the bottom. The fixed position div was a workaround */}
            <div className={backgroundOregon}></div> 
            <Header1 
            pageTitle="migrant histories" 
            pageSubtitle="a political timeline of immigration in Oregon"
            /* pulls data from JSON for intro text*/
            introText={ headerdata.filter(d => d.id == "story-intro")[0].text }></Header1>
                <div className={chapterContainer}>
                    <AnchorLink className={chapter} to={"#" + headerdata[1].id}>
                            <p className={chapterDate}>{headerdata[1].startDate + "-" + headerdata[1].endDate}</p>
                            <p>{headerdata[1].shortTitle}</p>
                    </AnchorLink>
                    <AnchorLink className={chapter} to={"#" + headerdata[2].id}>
                            <p className={chapterDate}>{headerdata[2].startDate + "-" + headerdata[2].endDate}</p>
                            <p>{headerdata[2].shortTitle}</p>
                    </AnchorLink>
                    <AnchorLink className={chapter} to={"#" + headerdata[3].id}>
                            <p className={chapterDate}>{headerdata[3].startDate + "-" + headerdata[3].endDate}</p>
                            <p>{headerdata[3].shortTitle}</p>
                    </AnchorLink>
                    <AnchorLink className={chapter} to={"#" + headerdata[4].id}>
                            <p className={chapterDate}>{headerdata[4].startDate + "-" + headerdata[4].endDate}</p>
                            <p>{headerdata[4].shortTitle}</p>
                    </AnchorLink>
                </div>
                <div className={legendContainer}>
                    <div className={legendItemContainer}>
                        <img src={politicalIcon} className={legendIcon}></img>
                        <div className={categoryContent} style={{color: "var(--polileg-color)"}}>
                            <p className={categoryTitle}>Politics / Legislation</p>
                            <p className={categoryText} >
                                Text describing each category goes here! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque imperdiet eget justo et lacinia. Praesent blandit, erat sed ornare hendrerit.
                            </p>
                        </div>
                    </div>
                    <div className={legendItemContainer}>
                        <img src={violenceIcon} className={legendIcon}></img>
                        <div className={categoryContent} style={{color: "var(--viol-color)"}}>
                            <p className={categoryTitle}>Anti-Immigration Violence</p>
                            <p className={categoryText} >
                                Text describing each category goes here! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque imperdiet eget justo et lacinia. Praesent blandit, erat sed ornare hendrerit.
                            </p>
                        </div>
                    </div>
                    <div className={legendItemContainer}>
                        <img src={actionIcon} className={legendIcon} ></img>
                        <div className={categoryContent} style={{color: "var(--action-color)"}}>
                            <p className={categoryTitle}>Anti-Immigrant Action</p>
                            <p className={categoryText} >
                                Text describing each category goes here! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque imperdiet eget justo et lacinia. Praesent blandit, erat sed ornare hendrerit.
                            </p>
                        </div>
                    </div>
                    <div className={legendItemContainer}>
                        <img src={grassrootsIcon} className={legendIcon} ></img>
                        <div className={categoryContent} style={{color: "var(--grassroots-color)"}}>
                            <p className={categoryTitle}>Grassroots / Civil Organizing</p>
                            <p className={categoryText} >
                                Text describing each category goes here! Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque imperdiet eget justo et lacinia. Praesent blandit, erat sed ornare hendrerit.
                            </p>
                        </div>
                    </div>
            </div>
           
                 <img src={legend} className={fixedLegend}></img>
           
            { pageContent /* this is the pageContent rendered dynamically from line 35-57 */} 
           
            
        </>
    )
    
}

export default OregonTimelinePage